export const movies = [
  {
    id: "peach-1993",
    title: "蜜桃成熟时",
    englishTitle: "Crazy Love",
    year: 1993,
    rating: 8.2,
    popularity: 98,
    duration: 95,
    director: "张肇麟",
    region: "中国香港",
    genres: ["剧情", "爱情"],
    tags: ["经典系列", "青春", "都市"],
    cast: ["li-lizhen", "pan-zhenwei", "cheng-kui-an"],
    cover:
      "https://readdy.ai/api/search-image?query=1990s%20Hong%20Kong%20art%20house%20film%20poster%20artwork%2C%20warm%20peach%20and%20cream%20tones%2C%20silhouette%20of%20a%20young%20woman%20walking%20through%20a%20sunlit%20city%20street%2C%20soft%20film%20grain%2C%20retro%20composition%20with%20gentle%20sunset%20glow%2C%20tasteful%20minimal%20design&width=600&height=900&seq=cover-peach-1993&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%201990s%20Hong%20Kong%20street%20at%20golden%20hour%2C%20warm%20peach%20and%20amber%20haze%2C%20soft%20film%20grain%2C%20distant%20figure%20walking%20past%20old%20shop%20signs%2C%20nostalgic%20melancholic%20mood%2C%20shallow%20depth%20of%20field&width=1600&height=900&seq=backdrop-peach-1993&orientation=landscape",
    summary:
      "九十年代都市青春片的代表作之一，以轻盈的笔触记录一个女孩在城市与情感之间的成长，被视作系列的开篇之作。",
    plot: [
      "故事发生在九十年代的香港。刚刚走出校园的阿桃对未来没有明确规划，在朋友的介绍下进入一家广告公司做助理。她一边适应快节奏的都市生活，一边在几段若即若离的关系中重新认识自己。",
      "影片没有把重心放在戏剧冲突上，而是用大量生活细节堆积人物的情绪：深夜的便利店、雨后的天台、录音机里循环的旧歌。阿桃在与家人、同事和朋友的碰撞中，逐渐学会为自己的选择负责。",
      "结尾处，她独自走在清晨的街道上，城市刚刚苏醒。影片用一个开放式的镜头收束，把成长留给了观众去想象。",
    ],
    highlights: ["系列开篇之作", "九十年代都市质感", "开放式成长叙事"],
  },
  {
    id: "peach-1997",
    title: "蜜桃成熟时1997",
    englishTitle: "Peach Blossom 1997",
    year: 1997,
    rating: 7.6,
    popularity: 88,
    duration: 92,
    director: "钱永强",
    region: "中国香港",
    genres: ["剧情", "爱情"],
    tags: ["经典系列", "青春", "都市"],
    cast: ["zhong-zhen", "lin-wei", "huang-rong"],
    cover:
      "https://readdy.ai/api/search-image?query=retro%20Hong%20Kong%20film%20poster%20with%20warm%20amber%20neon%20reflections%20on%20a%20rainy%20street%2C%20lone%20silhouette%20under%20an%20umbrella%2C%20soft%20peach%20and%20brown%20palette%2C%20film%20grain%20texture%2C%20moody%20cinematic%20composition%2C%20elegant%20minimal%20layout&width=600&height=900&seq=cover-peach-1997&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=rainy%20Hong%20Kong%20street%20at%20night%20with%20warm%20amber%20neon%20signs%20and%20wet%20reflections%2C%20soft%20orange%20haze%2C%20cinematic%20anamorphic%20look%2C%20film%20grain%2C%20lonely%20atmospheric%20mood&width=1600&height=900&seq=backdrop-peach-1997&orientation=landscape",
    summary:
      "系列第二部，把时间推向回归前夕的香港。两条交错的都市情感线，勾勒出那个特殊年份里年轻人的迷惘与热望。",
    plot: [
      "1997 年的夏天，香港的空气里既有期待也有不安。任职唱片店的小雨在旧区长大，她用一台相机记录即将消失的街景，也在记录自己说不出口的感情。",
      "另一边，从外地来港打拼的阿伟在夜班电台做主持，他习惯在节目里读听众来信，却从来没有认真读过自己写下的那封。两个原本陌生的人，因为一卷被误取的录音带产生交集。",
      "影片以城市变迁作为情感背景，把个人选择放到时代转折的语境中。结尾没有给出明确答案，只留下两把并排的伞和一条通向远方的街。",
    ],
    highlights: ["回归前夕的城市记忆", "双线叙事结构", "电台与录音带意象"],
  },
  {
    id: "peach-1999",
    title: "蜜桃成熟时3之蜜桃仙子",
    englishTitle: "Peach Fairy",
    year: 1999,
    rating: 7.1,
    popularity: 79,
    duration: 90,
    director: "陈树楷",
    region: "中国香港",
    genres: ["剧情", "爱情", "奇幻"],
    tags: ["经典系列", "青春", "都市"],
    cast: ["huang-rong", "zhong-zhen", "cheng-kui-an"],
    cover:
      "https://readdy.ai/api/search-image?query=dreamy%20film%20poster%20of%20a%20peach%20orchard%20in%20full%20bloom%2C%20soft%20pink%20and%20orange%20sunlight%2C%20young%20woman%20in%20a%20light%20summer%20dress%20seen%20from%20behind%2C%20ethereal%20glow%2C%20film%20grain%2C%20romantic%20nostalgic%20artwork&width=600&height=900&seq=cover-peach-1999&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=cinematic%20landscape%20of%20a%20peach%20orchard%20at%20sunrise%2C%20soft%20pink%20and%20warm%20orange%20light%20rays%20through%20blossoms%2C%20gentle%20morning%20mist%2C%20romantic%20dreamlike%20tone%2C%20shallow%20depth%20of%20field&width=1600&height=900&seq=backdrop-peach-1999&orientation=landscape",
    summary:
      "系列中风格最轻盈的一部，融入奇幻设定。误入人间的蜜桃仙子在都市里学会告别，也学会留下。",
    plot: [
      "传说每年桃花开尽时，看守果园的仙子可以下山一天。小桃第一次来到人间，对一切都感到新鲜，她遇见了在旧书店打工的青年阿树。",
      "一天很快过去，小桃却因为留恋而错过了回山的时间。她留在城市里，用最笨拙的方式理解人类的情感：帮阿树整理书、在雨天送伞、学着写一封不会寄出的信。",
      "影片用童话的壳包裹现实的议题，讨论拥有与失去。最后一幕里，果园的桃花再次开放，而人间多了一本被翻旧的书。",
    ],
    highlights: ["系列唯一奇幻设定", "桃花意象贯穿全片", "轻盈的童话质感"],
  },
  {
    id: "peach-2005",
    title: "蜜桃成熟时·青春纪事",
    englishTitle: "Peach Blossom: Youth Notes",
    year: 2005,
    rating: 7.0,
    popularity: 66,
    duration: 94,
    director: "林子皓",
    region: "中国香港",
    genres: ["剧情", "青春"],
    tags: ["青春", "都市"],
    cast: ["huang-rong", "lin-wei", "zhou-jialing"],
    cover:
      "https://readdy.ai/api/search-image?query=early%202000s%20coming%20of%20age%20film%20poster%2C%20three%20young%20friends%20on%20a%20seaside%20pier%20at%20sunset%2C%20warm%20peach%20and%20sand%20tones%2C%20soft%20lens%20flare%2C%20film%20grain%2C%20nostalgic%20summer%20mood%2C%20clean%20poster%20composition&width=600&height=900&seq=cover-peach-2005&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=summer%20seaside%20pier%20at%20golden%20sunset%2C%20warm%20peach%20and%20sand%20colored%20sky%2C%20gentle%20waves%2C%20soft%20lens%20flare%2C%20cinematic%20nostalgic%20coming%20of%20age%20atmosphere%2C%20distant%20silhouettes&width=1600&height=900&seq=backdrop-peach-2005&orientation=landscape",
    summary:
      "系列的外传式作品，聚焦三个女孩的毕业夏天。没有宏大叙事，只有关于友情、志愿与第一次告别的细碎记忆。",
    plot: [
      "毕业那年夏天，三个女孩约定在开学前完成一张清单：看一次日出、坐一次末班船、把没说完的话说完。",
      "清单一项项被划掉，她们也慢慢意识到，所谓长大并不是完成什么壮举，而是接受彼此会走向不同的地方。",
      "影片用纪录片式的手持镜头记录日常，把青春处理成一段可以被反复回看的家庭录像。",
    ],
    highlights: ["外传式青春群像", "海边夏日摄影", "清单式叙事"],
  },
  {
    id: "peach-2011",
    title: "蜜桃成熟时33D",
    englishTitle: "Peach Blossom 33D",
    year: 2011,
    rating: 6.8,
    popularity: 72,
    duration: 100,
    director: "陈翊恒",
    region: "中国香港",
    genres: ["剧情", "爱情", "奇幻"],
    tags: ["系列重启", "都市"],
    cast: ["chen-jing", "lin-wei", "pan-zhenwei"],
    cover:
      "https://readdy.ai/api/search-image?query=modern%20science%20fiction%20film%20poster%20with%20warm%20orange%20and%20copper%20gradient%2C%20abstract%20geometric%20light%20corridor%2C%20silhouette%20of%20a%20woman%20in%20motion%2C%20futuristic%20yet%20warm%20color%20palette%2C%20cinematic%20minimal%20composition&width=600&height=900&seq=cover-peach-2011&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=futuristic%20city%20skyline%20at%20dusk%20with%20warm%20copper%20and%20orange%20light%2C%20abstract%20light%20streaks%2C%20soft%20haze%2C%20cinematic%20science%20fiction%20atmosphere%2C%20elegant%20minimal%20composition&width=1600&height=900&seq=backdrop-peach-2011&orientation=landscape",
    summary:
      "系列时隔多年的重启之作，以时空交错的设定重新讲述「蜜桃」的故事，视觉风格转向都市科幻。",
    plot: [
      "一款名为「33D」的影像修复软件，意外把设计师阿静电脑里的旧照片变成了可以进入的空间。她在其中遇见了照片里的陌生女孩。",
      "随着修复的深入，现实与影像的边界开始模糊。阿静发现，自己正在修补的其实是一段被家人刻意遗忘的往事。",
      "影片把系列一贯的成长母题放进科幻框架，讨论记忆是否值得被完整保存。视觉上大量使用暖橙色光谱，形成独特的都市未来感。",
    ],
    highlights: ["系列视觉风格转型", "记忆与影像的科幻设定", "暖橙色光谱摄影"],
  },
  {
    id: "peach-2023",
    title: "蜜桃成熟时·幕后全纪录",
    englishTitle: "Peach Blossom: Behind the Lens",
    year: 2023,
    rating: 8.4,
    popularity: 84,
    duration: 86,
    director: "何蔚庭",
    region: "中国香港",
    genres: ["纪录片"],
    tags: ["专题", "经典系列"],
    cast: ["li-lizhen", "zhong-zhen", "cheng-kui-an"],
    cover:
      "https://readdy.ai/api/search-image?query=documentary%20film%20poster%20showing%20an%20editing%20desk%20with%20film%20reels%2C%20warm%20amber%20desk%20lamp%20light%2C%20vintage%20camera%20and%20contact%20sheets%2C%20soft%20peach%20and%20brown%20tones%2C%20nostalgic%20cinematic%20composition&width=600&height=900&seq=cover-peach-2023&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=warm%20dimly%20lit%20film%20editing%20room%20with%20vintage%20film%20reels%20and%20a%20projector%20casting%20amber%20light%2C%20soft%20dust%20in%20the%20air%2C%20nostalgic%20documentary%20atmosphere&width=1600&height=900&seq=backdrop-peach-2023&orientation=landscape",
    summary:
      "走访系列台前幕后主创的纪录片，从胶片修复、场景还原到演员访谈，完整梳理一个类型系列的三十年。",
    plot: [
      "纪录片以一次 4K 修复工程为线索，采访了摄影指导、美术指导、剪辑师与多位演员，还原当年拍摄现场的工作方式。",
      "片中也讨论了系列在不同年代引发的讨论与争议，主创们坦率地分享了自己的看法。",
      "对于影迷来说，这是一份难得的幕后档案；对于研究者来说，它提供了理解香港类型片工业的一个具体切片。",
    ],
    highlights: ["主创深度访谈", "4K 修复过程记录", "三十年系列档案"],
  },
  {
    id: "peach-2024",
    title: "蜜桃成熟时·夏日回声",
    englishTitle: "Peach Blossom: Summer Echo",
    year: 2024,
    rating: 8.6,
    popularity: 94,
    duration: 88,
    director: "黄绮琳",
    region: "中国香港",
    genres: ["剧情", "爱情"],
    tags: ["最新上映", "青春", "都市"],
    cast: ["zhong-zhen", "chen-jing", "zhou-jialing"],
    cover:
      "https://readdy.ai/api/search-image?query=contemporary%20film%20poster%20of%20a%20rooftop%20at%20summer%20sunset%2C%20two%20women%20silhouettes%20talking%20by%20a%20low%20wall%2C%20warm%20peach%20sky%2C%20soft%20grain%2C%20tender%20intimate%20mood%2C%20minimal%20elegant%20typography%20space&width=600&height=900&seq=cover-peach-2024&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Hong%20Kong%20rooftop%20at%20summer%20sunset%2C%20warm%20peach%20and%20orange%20sky%20with%20soft%20clouds%2C%20city%20skyline%20in%20haze%2C%20cinematic%20intimate%20atmosphere%2C%20gentle%20film%20grain&width=1600&height=900&seq=backdrop-peach-2024&orientation=landscape",
    summary:
      "系列三十周年纪念作品。两位多年未见的好友在一个夏天重逢，重新整理彼此共同的记忆。",
    plot: [
      "阿桃和阿夏曾是形影不离的朋友，后来因为一件小事断了联系。三十岁那年夏天，她们在同一栋旧楼的电梯里重逢。",
      "一次偶然的搬家，让两人重新翻出学生时代的录影带。画面里的她们年轻、笨拙，也毫无保留地相信未来。",
      "影片用极简的场景和大量对话推进，把友情中的错位与和解拍得克制又温柔。片尾曲响起时，镜头停留在被夕阳照亮的天台。",
    ],
    highlights: ["系列三十周年纪念", "双女主角细腻对手戏", "天台长镜头"],
  },
  {
    id: "peach-2025",
    title: "蜜桃成熟时·城市日记",
    englishTitle: "Peach Blossom: City Diary",
    year: 2025,
    rating: 8.0,
    popularity: 90,
    duration: 96,
    director: "陈小娟",
    region: "中国香港",
    genres: ["剧情", "都市"],
    tags: ["最新上映", "都市", "青春"],
    cast: ["chen-jing", "lin-wei", "li-lizhen"],
    cover:
      "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20poster%2C%20woman%20walking%20through%20a%20city%20at%20blue%20hour%20with%20warm%20orange%20shop%20lights%2C%20soft%20rain%2C%20reflective%20street%2C%20cinematic%20peach%20and%20brown%20palette%2C%20quiet%20melancholic%20mood&width=600&height=900&seq=cover-peach-2025&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=modern%20city%20street%20at%20dusk%2C%20warm%20orange%20shop%20windows%20against%20soft%20grey%20blue%20light%2C%20light%20rain%20and%20reflections%2C%20cinematic%20urban%20atmosphere%2C%20gentle%20film%20grain&width=1600&height=900&seq=backdrop-peach-2025&orientation=landscape",
    summary:
      "系列最新篇章。一位纪录片导演在拍摄城市变迁的过程中，重新遇见自己年轻时留下的影像日记。",
    plot: [
      "纪录片导演阿静回到旧区，拍摄一组关于拆迁的素材。在整理硬盘时，她发现了自己十年前拍下却没有剪完的半成品。",
      "镜头里的人如今散落在城市各处，有人离开，有人留下。阿静决定找到他们，把当年没问出口的问题重新问一遍。",
      "影片把创作焦虑与城市记忆交织在一起，是系列中对「记录」这一行为本身思考最深的一部。",
    ],
    highlights: ["元电影式叙事", "城市变迁记录", "系列最新篇章"],
  },
];

export const genreOptions = ["剧情", "爱情", "青春", "都市", "奇幻", "纪录片"];